import { useField } from 'formik';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { Input, InputOnlyProps } from 'ui';

export type FormikNumberInputProps = NumericFormatProps &
  InputOnlyProps & {
    name: string;
    changeProperty?: 'floatValue' | 'formattedValue' | 'value';
  };

export function FormikNumberInput({
  name,
  changeProperty = 'value',
  customInput,
  ...props
}: FormikNumberInputProps) {
  // Ignore onChange, we overwrite it with NumericFormat's onValueChange
  const [{ onBlur }, meta, helpers] = useField(name);

  return (
    <NumericFormat
      name={name}
      error={meta.error}
      defaultChecked={meta.initialValue}
      defaultValue={meta.initialValue}
      // @ts-expect-error It doesn't like the size prop...
      customInput={customInput || Input}
      onValueChange={values => helpers.setValue(values[changeProperty])}
      inputMode="numeric"
      onBlur={onBlur}
      {...props}
    />
  );
}
